<template>
  <div>
    <h3>{{ column.Name }}</h3>
    <b-card>
      <b-row>
        <b-col>
          <label>Namn:</label>
          <br />
          <b-input v-model="column.Name"></b-input>
        </b-col>
      </b-row>
      <b-row v-if="GetDataFormats(GetColType(column)).length > 0">
        <b-col>
          <b-card>
            <b-card-header>Värdeformat: </b-card-header>
            <b-card-body>
              <!-- <input type="text" v-model="column.Format" /> -->
              <b-form-select
                v-model="column.Format"
                :options="GetDataFormats(GetColType(column))"
              ></b-form-select>
            </b-card-body>
            <b-col> </b-col>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Kolumnbredd:</label><br />
          <!-- {{ column.Width }} -->
          <!-- <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            v-on:click="AdjWidth(column, -1)"
            title="Förminska"
          >
            -</button
          >&nbsp;
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            v-on:click="AdjWidth(column, 1)"
            title="Bredda"
            size="sm"
          >
            +
          </button> -->
          <br />
           <b-form-input id="range-2" v-model="column.Width" type="range" min="1" max="500" step="1"></b-form-input>
        </b-col>
        <b-col>
          <div class="btn-group mb-3">
            <button
              type="button"
              v-bind:class="GetAlignClass(column, 0)"
              v-on:click="SetAlign(column, 0)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-text-center"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                />
              </svg>
              <span class="visually-hidden">Vänster</span>
            </button>
            <button
              type="button"
              v-bind:class="GetAlignClass(column, 1)"
              v-on:click="SetAlign(column, 1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-text-center"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M4 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                ></path>
              </svg>
              <span class="visually-hidden">Centrerad</span>
            </button>
            <button
              type="button"
              v-bind:class="GetAlignClass(column, 2)"
              v-on:click="SetAlign(column, 2)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-text-center"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                />
              </svg>
              <span class="visually-hidden">Höger</span>
            </button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-checkbox v-model="column.Visible">Synlig</b-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-card>
          <b-card-header>Logisk formatering</b-card-header>
          <b-card-body>
            <table  style="width: 400px">
              <thead>
                <th colspan="3">Regel</th>
                <!-- <th style="width: 70%"></th> -->                
                <th>Bakgr.</th>
                <th>Text</th>
                <th></th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(cnd, i) in GetCnds()" :key="i" class="qv-row">
                  <td>{{ i + 1 }}</td>
                  <td>Mellan:</td>
                  <td style="width:120px">
                    <input v-model="cnd.min" style="width: 40px" />och<input
                      v-model="cnd.max"
                      style="width: 40px"
                    />
                  </td>
                  <td>
                    <verte
                      v-model="cnd.bgcolor"
                      :picker="'square'"
                      :model="'rgb'"
                      v-on:input="CndChange(cnd)"
                    ></verte>
                  </td>
                  <td>
                    <verte
                      v-model="cnd.color"
                      :picker="'square'"
                      :model="'rgb'"
                      v-on:input="CndChange(cnd)"
                    ></verte>
                  </td>
                  <td v-bind:style="GetStyle(cnd)">#</td>
                  <td class="fixedcell">
                    <b-icon-arrow-up
                      class="clickable"
                      @click="MoveCnd(i, -1)"
                    ></b-icon-arrow-up>
                    <b-icon-arrow-down
                      class="clickable"
                      @click="MoveCnd(i, 1)"
                    ></b-icon-arrow-down>
                    <b-icon-x-circle-fill
                      class="clickable"
                      @click="RemoveCnd(i)"
                    ></b-icon-x-circle-fill>
                  </td>
                </tr>
              </tbody>
            </table>
            <b-button @click="AddCnd()">+ Lägg till</b-button>
          </b-card-body>
        </b-card>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Verte from "verte";
import "verte/dist/verte.css";

export default {
  name: "queryviewcolumnstyle",
  components: { Verte },
  props: { column: Object },
  data() {
    return {
      dataformats: [
        { type: "date", text: "Oformaterat", value: "" },
        { type: "date", text: "Datum (ÅÅÅÅ-MM-DD)", value: "{0:yyyy-MM-dd}" },
        {
          type: "date",
          text: "Datum och tid (ÅÅÅÅ-MM-DD TT:MI)",
          value: "{0:yyyy-MM-dd HH:mm}",
        },
        {
          type: "date",
          text: "Datum (ÅÅÅÅMMDD)",
          value: "{0:yyyyMMdd}",
        },
        {
          type: "date",
          text: "Kort datum (ÅÅMMDD)",
          value: "{0:yyMMdd}",
        },
        {
          type: "date",
          text: "Tid (TT:MI)",
          value: "{0:HH:mm}",
        },
        {
          type: "numeric",
          text: "Oformaterat",
          value: "",
        },
        {
          type: "numeric",
          text: "Heltal",
          value: "{0:0}",
        },
        {
          type: "numeric",
          text: "En decimal (##.#)",
          value: "{0:0.0}",
        },
        {
          type: "numeric",
          text: "Två decimaler (##.##)",
          value: "{0:0.00}",
        },
        {
          type: "numeric",
          text: "Procent (%)",
          value: "{0:#0.##%}",
        },
        {
          type: "numeric",
          text: "Fraktsedel (### ### ### #)",
          value: "{0:### ### ### #}",
        },      
      ],
      workcsf: {},
      color: "",
    };
  },
  methods: {
    AdjWidth(c, adjustment) {
      const wtoadj = 10;
      if (!c.Width || c.Width == 0) c.Width = wtoadj;
      c.Width += adjustment * wtoadj;
      //this.setColumn(c);
    },
    //TODO: Move to common lib
    GetColType(c) {
      var ct = c.ColumnType.toLowerCase();
      if (ct.indexOf("date") >= 0) return "date";
      if (ct.indexOf("char") >= 0) return "text";
      // if (ct.indexOf("bit") >= 0) return 'bit';
        
      if (
        ct.indexOf("int") >= 0 ||
        ct.indexOf("bigint") ||
        ct.indexOf("decimal") ||
        ct.indexOf("numeric")
      )
        return "numeric";
    },
    GetDataFormats(coltype) {
      return this.dataformats.filter((x) => x.type == coltype);
    },
    GetAlignClass(c, align) {
      var res = { btn: true };
      if (c.csf && c.csf.align === align) res["btn-secondary"] = true;
      else res["btn-outline-secondary"] = true;

      return res;
    },
    SetAlign(c, align) {
      if (!c.csf) c.csf = {};
      c.csf.align = align;
      this.$forceUpdate();
    },
    GetCnds() {
      if (this.column.csf && this.column.csf.cnds) return this.column.csf.cnds;
      return [];
    },
    GetStyle(cnd) {
      if (cnd) {
        var res = [];
        if (cnd.bgcolor) res.push("background-color: " + cnd.bgcolor);
        if (cnd.color) res.push("color: " + cnd.color);
        return res.join(";");
      }

      return;
    },
    CndChange(cnd) {
      this.$forceUpdate();
    },
    AddCnd() {
      if (!this.column.csf) this.column.csf = {};
      if (!this.column.csf.cnds) this.column.csf.cnds = [];
      this.column.csf.cnds.push({ type: "bwn" });
      this.$forceUpdate();
    },
    RemoveCnd(i) {
      this.column.csf.cnds.splice(i, 1);
      this.$forceUpdate();
    },
    MoveCnd(i, dir) {
      var cnd = this.column.csf.cnds[i];
      this.column.csf.cnds.splice(i, 1);
      //Add at new position
      var newPos = i + dir;
      if (newPos < 0) newPos = 0;
      this.column.csf.cnds.splice(newPos, 0, cnd);
      this.$forceUpdate();
    },
  },
};
</script>
<style  scoped>

th {
    vertical-align: middle;
    text-align: left;
    border: 1px solid darkgray;
    background-color: lightgrey;
  }
  td {
    vertical-align: middle;
    text-align: left;
    border: 1px solid darkgray;
  }

</style>